import React, { useState } from 'react';
import { colours } from 'styling/colours';
import styled from 'styled-components';
import { icons } from 'assets/icons/index';
import LoadingDots from 'components/Loading/LoadingDots';
import { alertErrorMessage } from 'utils/alerts';
import { Asset } from 'types/asset';
import { getAssetById } from 'api/assets.api';
import { getWindowURL } from 'utils/utils';

const StyledButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 222px;
  height: 40px;
  font-size: 15px;
  text-align: center;
  background: #f6f7f9;
  outline: none;
  border: none;
  margin: 15px 0 5px 0;
  color: ${colours.secondary};
  text-decoration: underline;
  img {
    margin-right: 10px;
  }
  &:hover {
    cursor: pointer;
    background: #f6f7f9;
    text-decoration: underline;
  }
`;

export default function ViewAssetOnMapLink({ asset }: { asset: Asset }) {
  const [loading, setloading] = useState(false);
  // simple a tag link to render on asset detail flyout with URL params.
  // will not render without required params.

  const assetIsOutdoor = asset.location.is_outdoors;
  const venueID = asset.location.venue.id;
  const buildingID = asset.location?.building_level?.possible_buildings[0]?.id;
  const beaconID = asset.assigned_beacon?.id;
  const levelID = asset.location.building_level?.level.id;
  const allRequiredValuesExist = assetIsOutdoor
    ? beaconID !== null
    : venueID !== null && buildingID !== null && beaconID !== null && levelID !== null;

  function handleClick(asset: Asset) {
    if (!beaconID)
      return;
    setloading(true);

    getAssetById(asset.asset_id)
      .then((asset: Asset | null) => {
        if (!asset)
          return
        const assetIsOutdoor = asset.location?.is_outdoors;
        const resVenueID = asset.location?.venue.id;
        let constructedURL = '';

        if (assetIsOutdoor) {
          constructedURL = `${getWindowURL()}/map?is_outdoors=true&venue_id=${resVenueID}&beacon_id=${beaconID}`;
        } else {
          const resBuildingID = asset.location?.building_level.possible_buildings[0].id;
          const resLevelID = asset.location.building_level?.level.id;

          constructedURL = `${getWindowURL()}/map?venue_id=${resVenueID}&building_id=${resBuildingID}&level_id=${resLevelID}&beacon_id=${beaconID}`;
        }

        window.open(constructedURL, '_blank');
        setloading(false);
      })
      .catch((err) => {
        console.log(err);
        alertErrorMessage('Error fetching estimate details');
      });
  }

  if (!asset || !asset.assigned_beacon)
    return null;

  return allRequiredValuesExist ? (
    <StyledButton onClick={() => handleClick(asset)}>
      {loading ? (
        <LoadingDots />
      ) : (
        <>
          <icons.BlueMapIcon aria-label="View Asset on Map" />&nbsp;&nbsp;
          View asset on the map
        </>
      )}
    </StyledButton>
  ) : null;
}
